import { z } from 'zod';
import { objectIdSchema } from './objectId';

export const BrandSegmentSchema = z.object({
  _id: objectIdSchema,
  name: z.string().optional(),
  color: z.string().optional(),
});
